import $ from "jquery"
import {triggerTrackEvent} from "./Tracking.js";

class AOForms {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("FormComponent::initialize()")

		// prevent submit with Enter
		$("body").on("keydown", "form.ao-form", (event) => {
			if (event.key === "Enter" && !event.target.matches("textarea")) event.preventDefault()
		})

		// track valid Act-On form submissions
		$("body").on("submit", "form.ao-form", (event) => {
			// Act-On attaches its own submit listener to the form and calls
			// preventDefault() when its custom validation fails; on a valid
			// submit it does not prevent the default action. Because that
			// listener runs on the form before the event bubbles up to body,
			// reading the native event's defaultPrevented here is a reliable
			// "valid submission" signal.
			const nativeEvent = event.originalEvent || event
			if (nativeEvent.defaultPrevented) return

			const form = $(event.target).closest("form")[0]
			const formId = ($(form).attr("id") || "")

			triggerTrackEvent("form_submit_acton", "id", formId)
		})
	}
}

export default AOForms
